import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A2540] shadow-lg' : 'bg-[#0A2540]'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="/" rel="home" aria-label="HomePro Dispatch Home" className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center bg-[#FF6B00] rounded-md flex-shrink-0">
            <i className="ri-home-gear-fill text-white text-lg" />
          </div>
          <span className="text-white font-bold text-lg tracking-tight font-heading whitespace-nowrap">
            HomePro<span className="text-[#FF6B00]">Dispatch</span>
          </span>
        </a>

        {/* Desktop right side */}
        <div className="hidden md:flex items-center gap-6">
        <nav className="hidden md:flex items-center gap-5 text-white/80 text-sm font-medium" aria-label="Primary navigation">
            <a href="#services" className="hover:text-white transition-colors whitespace-nowrap">Services</a>
            <a href="#why-us" className="hover:text-white transition-colors whitespace-nowrap">Why Us</a>
            <a href="#faq" className="hover:text-white transition-colors whitespace-nowrap">FAQ</a>
          </nav>
          <a
            href="tel:+18669524010"
            className="flex items-center gap-2 bg-[#FF6B00] text-white px-4 py-2 rounded-md text-sm font-bold hover:bg-orange-600 transition-colors whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm" />
            </div>
            Call for 24/7 Dispatch
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          aria-controls="mobile-nav-menu"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div id="mobile-nav-menu" className="md:hidden bg-[#0A2540] border-t border-white/10 px-6 py-4 flex flex-col gap-4" role="navigation" aria-label="Mobile navigation">
          <a href="#services" className="text-white/80 text-sm font-medium hover:text-white" onClick={() => setMobileOpen(false)}>Services</a>
          <a href="#why-us" className="text-white/80 text-sm font-medium hover:text-white" onClick={() => setMobileOpen(false)}>Why Us</a>
          <a href="#faq" className="text-white/80 text-sm font-medium hover:text-white" onClick={() => setMobileOpen(false)}>FAQ</a>
          <a
            href="tel:+18669524010"
            className="flex items-center gap-2 bg-[#FF6B00] text-white px-4 py-2 rounded-md text-sm font-bold w-fit"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm" />
            </div>
            Call for 24/7 Dispatch
          </a>
        </div>
      )}
    </header>
  );
}
